import URL from '../constants'

export async function checkLoginInformation(token) {

  const requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };
  try {
    const response = await fetch(
      `${URL.API_COMMUNITIES}api/checkLoginInformation?tk_user=${token} `,
      requestOptions
    );
    if (!response.ok) {
      throw new Error(`Error! status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (err) {
    console.log(err);
  }
}
